import React from 'react'
import { Box, Typography } from '@mui/material'
import Loader from 'src/designSystem/Loader'
import { useAdvancedOverviewState } from './api/AdvancedOverviewProvider'
import { CurrentRoleOverride } from './currentRole'
import { advancedColors } from './theme'
import { tracksUnavailableHeadline } from './tracksUnavailableHeadline'
import { usePatientRole } from './usePatientRole'

const Centered = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 4, textAlign: 'center' }}
  >
    {children}
  </Box>
)

// The service lets any care-team member write any role's plan, so production never guesses the role.
const PatientRoleProvider = ({ uid, children }: { uid: string; children: React.ReactNode }) => {
  const role = usePatientRole(uid)
  const overview = useAdvancedOverviewState()

  if (role) {
    return <CurrentRoleOverride role={role}>{children}</CurrentRoleOverride>
  }

  if (overview.status === 'loading') {
    return (
      <Centered>
        <Loader size="large" />
      </Centered>
    )
  }

  const notOnCareTeam = overview.status !== 'error'
  return (
    <Centered>
      <Box sx={{ maxWidth: 380 }}>
        <Typography variant="h3">{tracksUnavailableHeadline(notOnCareTeam)}</Typography>
        <Typography variant="subtitle1" sx={{ mt: 1, color: advancedColors.inkMuted }}>
          {notOnCareTeam
            ? 'You may not be on their Advanced care team.'
            : 'Reload the page. If it keeps happening, let the product team know.'}
        </Typography>
      </Box>
    </Centered>
  )
}

export default PatientRoleProvider
